import { Project, ProjectStatus, User, Persona, SentimentData, DashboardMetric } from '../types';

export const mockUser: User = {
  id: '1',
  name: 'Onno de Jager',
  email: 'onno.dejager@constructa.nl',
  initials: 'OJ',
  organization: 'Constructa',
};

export const mockProjects: Project[] = [
  {
    id: '1',
    name: 'A1 Amersfoort-Apeldoorn',
    fullName: 'A1 Amersfoort-Apeldoorn: Verbetering Doorstroming & Leefbaarheid',
    location: 'Barneveld, Gelderland',
    period: 'Oktober 2025 - December 2027',
    status: ProjectStatus.UitvoeringKritiek,
    statusLabel: 'Uitvoering - Kritieke fase',
    image: 'harriekuipers_Epic_panoramic_image_of_the_Afsluitdijk_in_the__653d89e3-7744-4abd-be81-6dbbed3a071b_1.png',
  },
  {
    id: '2',
    name: 'Kustversterking Petten',
    fullName: 'Kustpact 2050: Versterking Kustlijn Petten',
    location: 'Petten-aan-Zee, Noord-Holland',
    period: 'Februari 2026 - September 2026',
    status: ProjectStatus.Voorbereiding,
    statusLabel: 'Voorbereiding',
    image: 'harriekuipers_Ultra-realistic_aerial_view_of_the_A27_highway__b4c8b799-1503-4fab-ae2c-728625d6028b_0.png',
  },
  {
    id: '3',
    name: 'Sluizen Maasbracht',
    fullName: 'Toekomstbestendige Maas: Groot Onderhoud Sluizen Maasbracht',
    location: 'Maasbracht, Limburg',
    period: 'Oktober 2025 - November 2025',
    status: ProjectStatus.Uitvoering,
    statusLabel: 'Uitvoering',
    image: 'harriekuipers_Wide_shot_of_new_highway_connection_cutting_thr_fb2a99e1-4360-4d5d-ab02-0433c6d5fa33_1.png',
  },
];

export const mockDashboardMetrics: DashboardMetric[] = [
  {
    icon: null,
    iconBackground: 'rgba(230, 0, 126, 0.15)',
    value: '1,247',
    label: 'Stakeholders',
    change: {
      value: '+12%',
      type: 'positive',
    },
  },
  {
    icon: null,
    iconBackground: 'rgba(39, 124, 234, 0.15)',
    value: '68%',
    label: 'Positief Sentiment',
    change: {
      value: '-5%',
      type: 'negative',
    },
  },
  {
    icon: null,
    iconBackground: 'rgba(0, 200, 83, 0.15)',
    value: '312',
    label: 'Actieve Issues',
    change: {
      value: '0%',
      type: 'neutral',
    },
  },
  {
    icon: null,
    iconBackground: 'rgba(255, 107, 53, 0.15)',
    value: '45%',
    label: 'Voortgang',
    change: {
      value: '+8%',
      type: 'positive',
    },
  },
];

export const mockPersonas: Persona[] = [
  {
    id: '1',
    name: 'Jan van der Berg',
    age: 45,
    occupation: 'Bewoner aangrenzende wijk',
    description: 'Gezinsman, werkt fulltime, maakt zich zorgen over overlast tijdens werkzaamheden.',
    concerns: ['Geluidsoverlast', 'Bereikbaarheid woning', 'Veiligheid kinderen'],
    communication: ['Digitale nieuwsbrief', 'Persoonlijke brief', 'WhatsApp updates'],
    initials: 'JB',
  },
  {
    id: '2',
    name: 'Maria de Vries',
    age: 67,
    occupation: 'Gepensioneerde',
    description: 'Woont al 40 jaar in de buurt, actief in buurtvereniging.',
    concerns: ['Trillingen in woning', 'Waardevermindering huis', 'Duur van het project'],
    communication: ['Papieren brieven', 'Inloopavonden', 'Telefonisch contact'],
    initials: 'MV',
  },
  {
    id: '3',
    name: 'Ahmed Hassan',
    age: 32,
    occupation: 'Ondernemer - eigenaar lokale supermarkt',
    description: 'Bezorgd over bereikbaarheid winkel en klantenverlies.',
    concerns: ['Bereikbaarheid voor leveranciers', 'Parkeerplaatsen', 'Omzetverlies'],
    communication: ['Email updates', 'Persoonlijk gesprek', 'Zakelijke nieuwsbrief'],
    initials: 'AH',
  },
  {
    id: '4',
    name: 'Sophie Bakker',
    age: 28,
    occupation: 'Forens - dagelijks treinreiziger',
    description: 'Reist dagelijks met de trein voor werk, flexibele werktijden.',
    concerns: ['Reistijd vertraging', 'Alternative routes', 'Real-time updates'],
    communication: ['App notificaties', 'Social media', 'Station displays'],
    initials: 'SB',
  },
];

export const mockSentimentData: SentimentData[] = [
  { date: '2024-01-01', positive: 65, neutral: 25, negative: 10 },
  { date: '2024-02-01', positive: 68, neutral: 22, negative: 10 },
  { date: '2024-03-01', positive: 70, neutral: 20, negative: 10 },
  { date: '2024-04-01', positive: 72, neutral: 20, negative: 8 },
  { date: '2024-05-01', positive: 68, neutral: 24, negative: 8 },
  { date: '2024-06-01', positive: 68, neutral: 25, negative: 7 },
];